import { MenuInterface, MenuTransversal } from '@/interfaces/menu';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { useContext, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import UseTraceItemShipping from '../../../hooks/useTraceItemShipping';
import { LoginGigyaInterface } from '@/shared/interfaces/LoginGigyaInterface';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { normalizeTwoWords } from '../../../shared/utils/stringUtilities';
import { getLocationRef } from '../../../utils/location';
import { normalizeWords } from '../../../utils/normalizeWords';
import ButtonBurger from '../../atoms/button-burger/buttonBurger';
import Login from '../../atoms/login/login';
import BusinessModal from '../bussiness-modal/businessModal';
import Submenu from '../submenu/submenu';
import SearcherBarHeader from '../search-bar-header/SearchBarHeader';
import HeaderTab from '@/components/atoms/header-tab/headerTab';
import CloseBtn from '@/assets/images/icons/close_black_24dp.svg';
import Button from '@/components/atoms/button/button';
import Modal from '@/components/atoms/modal/modal';
import './menu.scss';

const Menu = (props: MenuInterface) => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_TRANSVERSAL_DATA {
            allContentfulMenuLoggin(
                filter: { titulo: { eq: "Menu login portal de servicios" } }
            ) {
                nodes {
                    inicioSesion
                }
            }
            allContentfulTransversal(
                filter: { tituloFiltro: { eq: "Transversal portal servicios" } }
            ) {
                nodes {
                    header {
                        referencias {
                            ... on ContentfulTemplate {
                                nombre
                                copyBoton
                                redireccion
                                imagen {
                                    file {
                                        url
                                    }
                                }
                            }
                        }
                    }
                    titulo
                    logo {
                        title
                        file {
                            url
                        }
                        description
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                    menuTransversal {
                        titulo
                        referencias {
                            ... on ContentfulTemplate {
                                nombre
                                referencias {
                                    ... on ContentfulTemplate {
                                        titulo
                                        nombre
                                        redireccion
                                        number
                                        referencias {
                                            ... on ContentfulTemplate {
                                                titulo
                                                nombre
                                                redireccion
                                                descripcion {
                                                    raw
                                                }
                                                imagen {
                                                    title
                                                    description
                                                    file {
                                                        url
                                                    }
                                                    gatsbyImageData(
                                                        formats: [AUTO, WEBP]
                                                        placeholder: BLURRED
                                                    )
                                                }
                                                referencias {
                                                    ... on ContentfulTemplate {
                                                        titulo
                                                        nombre
                                                        subtitulo
                                                        redireccion
                                                        interrogationIcon
                                                        iconoInterrogante {
                                                            title
                                                            file {
                                                                url
                                                            }
                                                            gatsbyImageData(
                                                                formats: [
                                                                    AUTO
                                                                    WEBP
                                                                ]
                                                                placeholder: BLURRED
                                                            )
                                                        }
                                                        lockedIcon
                                                        iconoCandado {
                                                            title
                                                            file {
                                                                url
                                                            }
                                                            gatsbyImageData(
                                                                formats: [
                                                                    AUTO
                                                                    WEBP
                                                                ]
                                                                placeholder: BLURRED
                                                            )
                                                        }
                                                        interrogationDescription {
                                                            raw
                                                        }
                                                        referencias {
                                                            ... on ContentfulTemplate {
                                                                nombre
                                                                redireccion
                                                                interrogationIcon
                                                                iconoInterrogante {
                                                                    title
                                                                    file {
                                                                        url
                                                                    }
                                                                    gatsbyImageData(
                                                                        formats: [
                                                                            AUTO
                                                                            WEBP
                                                                        ]
                                                                        placeholder: BLURRED
                                                                    )
                                                                }
                                                                interrogationDescription {
                                                                    raw
                                                                }
                                                                lockedIcon
                                                                iconoCandado {
                                                                    title
                                                                    file {
                                                                        url
                                                                    }
                                                                    gatsbyImageData(
                                                                        formats: [
                                                                            AUTO
                                                                            WEBP
                                                                        ]
                                                                        placeholder: BLURRED
                                                                    )
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        secciones {
                                            nombre
                                            subtitulo
                                            referencias {
                                                ... on ContentfulTemplate {
                                                    nombre
                                                    imagen {
                                                        title
                                                        file {
                                                            url
                                                        }
                                                    }
                                                    redireccion
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    menuUsuario {
                        titulo
                        nombreEmpresa
                        descripcion {
                            raw
                        }
                        referencias {
                            ... on ContentfulTemplate {
                                titulo
                                nombre
                                redireccion
                                imagen {
                                    title
                                    file {
                                        url
                                    }
                                    gatsbyImageData(
                                        formats: [AUTO, WEBP]
                                        placeholder: BLURRED
                                    )
                                }
                                lista
                            }
                        }
                    }
                }
            }
        }
    `);
    const { selectedTab, gigyaContext, userInfoContext, business } =
        useContext(GlobalContext);
    const menuData =
        data.allContentfulTransversal.nodes[0].header[0].referencias;
    const { window } = useBrowserMode();
    const [showSearcher, setShowSearcher] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);
    const selectedMenu: MenuTransversal =
        selectedTab?.get === TabsEnum.PEOPLE
            ? data.allContentfulTransversal.nodes.filter(
                  (menu) =>
                      menu.titulo === 'Transversal portal servicios personas'
              )[0].menuTransversal
            : data.allContentfulTransversal.nodes.filter(
                  (menu) =>
                      menu.titulo === 'Transversal portal servicios empresas'
              )[0].menuTransversal;

    const menuTransversal = selectedMenu.referencias.filter(
        (menu) =>
            menu.nombre ===
            `${
                !gigyaContext.gigyaAccount
                    ? selectedTab?.get === TabsEnum.PEOPLE
                        ? 'Menú público personas'
                        : 'Menú público'
                    : selectedTab?.get === TabsEnum.PEOPLE
                    ? 'Menú privado personas'
                    : 'Menú privado'
            }`
    )[0];

    const menuUsuario =
        selectedTab?.get === TabsEnum.PEOPLE
            ? data.allContentfulTransversal.nodes.filter(
                  (menu) =>
                      menu.titulo === 'Transversal portal servicios personas'
              )[0].menuUsuario
            : data.allContentfulTransversal.nodes.filter(
                  (menu) =>
                      menu.titulo === 'Transversal portal servicios empresas'
              )[0].menuUsuario;

    const { selectedOption, setSelectedOption, close } = props;
    const [isMenuActive, setMenuActive] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const { inicioSesion } = data.allContentfulMenuLoggin.nodes[0];

    const handleClick = (clickedOption) => {
        clickedOption === selectedOption
            ? setSelectedOption(null)
            : setSelectedOption(clickedOption);
    };

    const toogleFreeze = (isToggle: boolean) => {
        isToggle
            ? document.body.classList.add('freeze-page')
            : document.body.classList.remove('freeze-page');
    };

    const openMenu = () => {
        toogleFreeze(true);
        setMenuActive(true);
    };
    const closeMenu = () => {
        toogleFreeze(false);
        setMenuActive(false);
    };
    const closeModal = () => {
        setOpenModal(false);
    };

    const renderLoginButton = ({
        login,
        logout,
        updateProfile,
        gigyaAccount,
    }: LoginGigyaInterface) => {
        return (
            <Login
                isMenuActive={false}
                title={inicioSesion}
                login={login}
                logout={logout}
                updateProfile={updateProfile}
                gigyaAccount={gigyaAccount}
                menuUser={menuUsuario}
                closeMenu={closeMenu}
                openModal={() => {
                    setOpenModal(true);
                }}
                isPrivate={props.isPrivate}
            />
        );
    };

    const isSecondaryOptionActive = (redireccion) => {
        const pathname = window?.location?.pathname;
        return pathname?.includes(redireccion)
            ? 'm-menu__options-secondary__item-active'
            : '';
    };

    const handleTabChange = (tab: TabsEnum) => {
        const bussinesOrigin = window.location.pathname.includes('empresas');

        if (tab === TabsEnum.BUSINESS) {
            if (!business?.get) {
                if (!bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                } else {
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                }
            } else {
                if (bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                } else {
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                }
            }
        }

        if (tab === TabsEnum.PEOPLE) {
            if (
                localStorage.getItem('CURRENT_TAB') !== tab &&
                selectedTab?.get !== tab
            ) {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);
                location.href =
                    tab === TabsEnum.PEOPLE &&
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            } else {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);

                location.href =
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            }
        }
    };

    const closeModalPermissionPage = () => {
        setOpenModal(false);
    };

    const onSendTraceItemShipping = (option) => {
        if (!gigyaContext?.gigyaAccount) return;
        UseTraceItemShipping(
            gigyaContext?.gigyaAccount?.profile.firstName +
                ' ' +
                (gigyaContext.gigyaAccount.data.secondName
                    ? gigyaContext.gigyaAccount.data.secondName + ' '
                    : '') +
                gigyaContext.gigyaAccount.profile.lastName +
                (gigyaContext.gigyaAccount.data.secondLastName
                    ? ' ' + gigyaContext.gigyaAccount.data.secondLastName
                    : ''),
            gigyaContext?.gigyaAccount?.data.docNumber,
            gigyaContext?.gigyaAccount?.data.docType,
            gigyaContext?.gigyaAccount?.profile.email,
            'click',
            `${normalizeWords(option.nombre)}`,
            userInfoContext.data?.userJwt
        );
    };

    const handleTabChangeTwo = () => {
        const bussinesOrigin = window.location.pathname.includes('empresas');
        const tab = localStorage.getItem('CURRENT_TAB');
        if (tab === TabsEnum.BUSINESS) {
            if (!business?.get) {
                if (!bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                } else {
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                }
            } else {
                if (bussinesOrigin) {
                    localStorage.setItem('CURRENT_TAB', tab);
                    selectedTab?.set(tab);
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                } else {
                    location.href =
                        window?.location.hostname === 'localhost'
                            ? '/empresas'
                            : '/portal-servicios/empresas';
                }
            }
        }

        if (tab === TabsEnum.PEOPLE) {
            if (
                localStorage.getItem('CURRENT_TAB') !== tab &&
                selectedTab?.get !== tab
            ) {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);
                location.href =
                    tab === TabsEnum.PEOPLE &&
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            } else {
                localStorage.setItem('CURRENT_TAB', tab);
                selectedTab?.set(tab);

                location.href =
                    window?.location.hostname === 'localhost'
                        ? '/personas'
                        : '/portal-servicios/personas';
            }
        }
    };

    const infoModal = () => {
        return (
            <div className="o-massive-certificate-form__modal__container">
                <div
                    className="o-massive-certificate-form__modal__container__closeBtn"
                    onClick={() => {
                        setShowInfoModal(false);
                    }}
                >
                    <img src={CloseBtn} alt="closeButton" />
                </div>
                <div className="o-massive-certificate-form__modal__container__content">
                    <div className="o-massive-certificate-form__modal__container__content__img">
                        <i className="icon-info-circle1"></i>
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__title">
                        <h2>¡Noticia importante de afiliaciones!</h2>
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__descriptionOne">
                        <p>
                            Este 16 de diciembre desde 7:00 a.m. realizaremos
                            mantenimiento de nuestra plataforma de afiliaciones,
                            por lo que no se podrán realizar afiliaciones de
                            trabajadores dependientes. El proceso volverá a la
                            normalidad este 17 de diciembre a las 12 m.m
                        </p>
                    </div>
                    <div className="o-massive-certificate-form__modal__container__content__buttons">
                        <Button
                            type="button"
                            classname="secondary"
                            text={'Entendido'}
                            onClickAction={() => handleTabChangeTwo()}
                            isDisabled={false}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <GlobalContext.Consumer>
            {(data) => (
                <div>
                    <nav className={'m-menu'}>
                        <>
                            {menuTransversal?.referencias
                                ?.slice(0, 1)
                                .map((option, index) => {
                                    return (
                                        <div
                                            className="m-menu__burger hide-on-mobile"
                                            key={index}
                                        >
                                            <ButtonBurger
                                                isMenuActive={
                                                    selectedOption === index
                                                }
                                                lastDirection={0}
                                                hideHeaderDesktop={true}
                                                closeMenu={() =>
                                                    handleClick(index)
                                                }
                                                openMenu={() =>
                                                    handleClick(index)
                                                }
                                            />

                                            {index === 0 &&
                                                option.referencias && (
                                                    <Submenu
                                                        content={
                                                            option.referencias
                                                        }
                                                        isDark={props.isDark}
                                                        actionTheme={
                                                            props.actionTheme
                                                        }
                                                        isServiceMenu={
                                                            index === 0
                                                        }
                                                        show={
                                                            selectedOption ===
                                                            index
                                                        }
                                                        isSearcherActive={
                                                            props.isSearcherActive
                                                        }
                                                        setSearcherActive={
                                                            props.setSearcherActive
                                                        }
                                                        close={close}
                                                        traceLabel={
                                                            option.nombre
                                                        }
                                                        positionPayment={
                                                            option.number
                                                        }
                                                        isPrivate={
                                                            props.isPrivate
                                                        }
                                                        sections={
                                                            option.secciones
                                                        }
                                                        //   isMobile={true}
                                                    />
                                                )}
                                        </div>
                                    );
                                })}
                            <ul className={'m-menu__options hide-on-mobile'}>
                                {showSearcher ? (
                                    <div className="m-menu__searcherContainer">
                                        <div className="m-menu__searcherContainer__searcher">
                                            <SearcherBarHeader
                                                type="comfama"
                                                placement="inside"
                                                defaultPlaceholder={'buscar'}
                                                setShowInfoModal={
                                                    setShowInfoModal
                                                }
                                            />
                                        </div>
                                        <div className="m-menu__searcherContainer__cancelBtn">
                                            <p
                                                onClick={() =>
                                                    setShowSearcher(false)
                                                }
                                            >
                                                Cancelar
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="m-menu__utilityIcons__searchIconContainer"
                                        onClick={() => setShowSearcher(true)}
                                    >
                                        <i className="icon-search" />
                                    </div>
                                )}

                                <div className="m-menu__utilityIcons__separator" />
                                {menuTransversal?.referencias
                                    ?.slice(1, 2)
                                    .map((option, index) => {
                                        return (
                                            <li key={`menu-item-${index}`}>
                                                <span
                                                    className={`m-menu__options-item ${
                                                        selectedOption === index
                                                            ? 'm-menu__options-item--active'
                                                            : ''
                                                    }
                                                    ${
                                                        option.titulo.includes(
                                                            'empresas'
                                                        )
                                                            ? 'gtmHomeEmpresasClicMenu'
                                                            : 'gtmHomePersonasClicMenu'
                                                    }${normalizeTwoWords(
                                                        option.nombre
                                                    )}
                                                    `}
                                                    //   onClick={() => handleClick(index)}
                                                >
                                                    <Link
                                                        className={`m-menu__options-secondary__item ${isSecondaryOptionActive(
                                                            option.redireccion
                                                        )}${
                                                            option.titulo.includes(
                                                                'empresas'
                                                            )
                                                                ? 'gtmHomeEmpresasClicMenu'
                                                                : 'gtmHomePersonasClicMenu'
                                                        }${normalizeTwoWords(
                                                            option.nombre
                                                        )}`}
                                                        to={getLocationRef(
                                                            option.redireccion
                                                        )}
                                                        onClick={() => {
                                                            onSendTraceItemShipping(
                                                                option
                                                            );
                                                            setSelectedOption(
                                                                null
                                                            );
                                                        }}
                                                    >
                                                        {option.nombre}
                                                    </Link>
                                                </span>
                                            </li>
                                        );
                                    })}
                            </ul>
                            <div className="m-menu__utilityIcons show-on-mobile">
                                {showSearcher ? (
                                    <div className="m-menu__searcherContainer">
                                        <div className="m-menu__searcherContainer__searcher">
                                            <SearcherBarHeader
                                                type="comfama"
                                                placement="inside"
                                                defaultPlaceholder={'buscar'}
                                                setShowInfoModal={
                                                    setShowInfoModal
                                                }
                                            />
                                        </div>
                                        <div className="m-menu__searcherContainer__cancelBtn">
                                            <p
                                                onClick={() =>
                                                    setShowSearcher(false)
                                                }
                                            >
                                                Cancelar
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <HeaderTab
                                            tabContent={menuData[0]}
                                            isTabActive={
                                                selectedTab?.get ===
                                                TabsEnum.PEOPLE
                                            }
                                            handleClick={() =>
                                                handleTabChange(TabsEnum.PEOPLE)
                                            }
                                            isWhite={true}
                                        />
                                        <HeaderTab
                                            tabContent={menuData[1]}
                                            isTabActive={
                                                selectedTab?.get ===
                                                TabsEnum.BUSINESS
                                            }
                                            handleClick={() =>
                                                handleTabChange(
                                                    TabsEnum.BUSINESS
                                                )
                                            }
                                            isWhite={true}
                                        />
                                        <div
                                            className="m-menu__utilityIcons__searchIconContainer"
                                            onClick={() =>
                                                setShowSearcher(true)
                                            }
                                        >
                                            <i className="icon-search" />
                                        </div>
                                        <div className="m-menu__utilityIcons__separator" />

                                        <div className="m-menu__utilityIcons__userSessionContainer">
                                            {renderLoginButton(
                                                data.gigyaContext
                                            )}
                                        </div>
                                        <div className="m-menu__burger show-on-mobile">
                                            <ButtonBurger
                                                isMenuActive={isMenuActive}
                                                // isSearcherActive={false}
                                                lastDirection={0}
                                                hideHeaderDesktop={true}
                                                closeMenu={closeMenu}
                                                openMenu={openMenu}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    </nav>

                    <div className="submenu show-on-mobile">
                        <Submenu
                            content={menuTransversal?.referencias}
                            isMenuActive={isMenuActive}
                            isMobile={true}
                            isDark={props.isDark}
                            actionTheme={props.actionTheme}
                            isServiceMenu={false}
                            isSearcherActive={props.isSearcherActive}
                            setSearcherActive={props.setSearcherActive}
                            closeMenu={closeMenu}
                            isPrivate={props.isPrivate}
                            sections={
                                menuTransversal?.referencias[0]?.secciones
                            }
                        />
                    </div>
                    {showInfoModal && (
                        <Modal
                            open={showInfoModal}
                            onClose={() => setShowInfoModal(false)}
                        >
                            {infoModal()}
                        </Modal>
                    )}
                    {openModal && (
                        <BusinessModal
                            closeModal={closeModal}
                            isMobile={true}
                            setShowConfirmation={setShowConfirmation}
                            isPrivate={props.isPrivate}
                            closeModalPermissionPage={closeModalPermissionPage}
                            serviceId={props.serviceId}
                        />
                    )}
                    {showConfirmation && <>{showConfirmation}</>}
                </div>
            )}
        </GlobalContext.Consumer>
    );
};

export default Menu;
